import axios from 'axios'

const API_URL = '/api/auth/';

class AuthService {
  resolveProvider(email) {
    return axios.get(API_URL + 'sso/resolve', { params: { email } })
      .then(res => res.data);
  }

  logout() {
    localStorage.removeItem('user');
  }

  getSession() {
    return axios.get(API_URL + 'session')
  }
}

export default new AuthService();
